<div mat-dialog-title>
	<h2>{{"reservations.Change Table" | translate}}</h2>
  <div>
    <button
      (click)="saveTable()"
      mat-raised-button color="primary"
      [disabled]="loading || !canChange"
      [class.loading]="loading">
      {{"reservations.Change Table" | translate}}
    </button>
    <button mat-button type="button" mat-dialog-close class="ml-2 btn-grey">
      {{"forms.Cancel" | translate}}
    </button>
  </div>
</div>

<mat-dialog-content class="large-content">
  <div class="mat-dialog-body">

    <p class="mt-0 has-error" *ngIf="isSubmitted && !selectedTables.length">
      {{'reservations.No tables selected' | translate}}
    </p>

    <div class="floor-view">
      <div *ngIf='(floorsLoading || floorLoading) && hardReload' class="dataLoading">
        <mat-spinner class="m-auto" diameter="50"></mat-spinner>
      </div>

      <div *ngIf="(!floorsLoading && floorsList?.length) || !hardReload">
        <ng-container *ngIf="!floorLoading">
          <app-floor-viewer
            [floor]="floor"
            [floorsList]="floorsList"
            [tablesToSelect]="tablesToSelect"
            [reservationResponse]="reservationResponse"
            (floorChange)="ResFloorsChangeTable($event)"
            (selectedTables)="selectedTables = $event; CheckReservation()"
            [canViewWaiters]="canViewWaiters"
          ></app-floor-viewer>
        </ng-container>
      </div>

      <ng-container *ngIf='!floorsLoading && !floorsList?.length'>
        <empty-state [title]='"general.No Data Found" | translate'></empty-state>
      </ng-container>
    </div>

  </div>
</mat-dialog-content>
